import { useMultiSelectFilter } from '@/scopes/search/search/domain/hooks'
import { getFilterAISelection } from '@/scopes/search/search/infrastructure/store/selectors'
import { useSearchStoreSelector } from '@/scopes/search/search/infrastructure/store/useSearchStore'
import { Token } from '@sunwebgroup/ui-components/uds'
import { equals, reject } from 'ramda'
import { useCallback } from 'react'

export function AccommodationTypeTokens() {
  const { isFetching, isLoading, selectedOptions, setSelection, selectedValues }
    = useMultiSelectFilter('AccommodationType')
  const aiSelectedValues = useSearchStoreSelector(getFilterAISelection, 'AccommodationType') as string[] ?? []

  const handleRemoveClick = useCallback(
    (value?: string) => {
      setSelection(reject(equals(value), selectedValues))
    },
    [selectedValues, setSelection],
  )

  if (isLoading)
    return null

  return selectedOptions.map(({ value, name }) => (
    <Token key={value} value={value} disabled={isFetching} dismissible onDismissClick={handleRemoveClick} icon={aiSelectedValues.find(aiValue => aiValue === value) ? 'Ai' : undefined}>
      {name}
    </Token>
  ))
}
